var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-paper-clip';
                    var viewUrl = 'gfx/sprite.svg#view-icon-paper-clip';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 418.188 418.187',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };